import React, { useState, useEffect } from "react";
import "./Sidebar.css";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import AddIcon from "@material-ui/icons/Add";
import SettingsIcon from "@material-ui/icons/Settings";
import SidebarChannel from "./SidebarChannel";
import { Avatar } from "@material-ui/core";
import { useSelector } from "react-redux";
import { selectUser } from "../features/userSlice";
import { auth } from "../firebase";
import db from "../firebase";

const Sidebar = () => {
  const user = useSelector(selectUser);
  const [show, setShow] = useState(false);
  const [channels, setChannels] = useState([]);

  useEffect(() => {
    db.collection("channels").onSnapshot((snapshot) => {
      setChannels(
        snapshot.docs.map((doc) => ({
          id: doc.id,
          channel: doc.data(),
        }))
      );
    });
  }, []);

  const handleAddChannel = () => {
    const channelName = prompt("Enter a new Channel");
    if (channelName) {
      db.collection("channels").add({
        channelName: channelName,
      });
    }
  }

  return (
    <div className="sidebar">
      <div className="sidebar__top">
        <h3>Room Anonymous</h3>
        <ExpandMoreIcon />
      </div>
      <div className="sidebar__channels">
        <div className="sidebar__channelsHeader">
          <div className="sidebar__header">
            <ExpandMoreIcon />
            <h4>Text Channels</h4>
          </div>
          <AddIcon onClick={handleAddChannel} className="sidebar__addChannel" />
        </div>
        <div className="sidebar__channelsList">
          {channels.map(({id ,channel}) => (
            <SidebarChannel key={id} id={id} channelName={channel.channelName}  />
          ))}
        </div>
      </div>
      <div className="sidebar__profile">
        <Avatar src={user.photo} />
        <div className="sidebar__profileInfo">
          <h3>{user.displayName}</h3>
          <p>#{user.uId.substring(0, 5)}</p>
        </div>
        <div className="sidebar__profileIcons settings__icon">
          <SettingsIcon
            onClick={() => {
              setShow(!show);
            }}
          />
          {show ? (
            <p className="logout__text" onClick={() => auth.signOut()}>
              Log Out
            </p>
          ) : (
            <span></span>
          )}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
